import { BasicSeries } from '../../../types/deal.types';
import { ValueGetterParamsDealVersion } from './value-getters.interface';
import { isDefined } from '../../../utils/utils';

export function taxStatusGetter(
  { data }: ValueGetterParamsDealVersion,
  abbreviate = true
): string[] {
  if (!isDefined(data)) {
    return [];
  }

  const series = data.series;

  if (series) {
    return series.reduce((acc: string[], srs: BasicSeries) => {
      const seriesStatus: string = taxStatusGetterForSeries(srs, abbreviate);
      if (acc.indexOf(seriesStatus) === -1) {
        acc.push(seriesStatus);
      }
      return acc;
    }, []);
  } else {
    return [];
  }
}

export function taxStatusGetterForSeries(
  series: BasicSeries,
  abbreviate = true
): string {
  if (abbreviate) {
    const seriesIsTaxable = series.isTaxable ? 'Tax' : 'T-E';

    const seriesIsAMT = series.isAMT ? 'AMT' : seriesIsTaxable;

    return series.corpCusip ? 'CORP' : seriesIsAMT;
  } else {
    const seriesIsTaxable = series.isTaxable ? 'Taxable' : 'Tax Exempt';

    const seriesIsAMT = series.isAMT ? 'AMT' : seriesIsTaxable;

    return series.corpCusip ? 'Corporate CUSIP' : seriesIsAMT;
  }
}

export function hasNotTaxableSeries(taxStatuses: string[]) {
  return taxStatuses.includes('T-E') || taxStatuses.includes('AMT');
}

export function hasTaxableSeries(taxStatuses: string[]) {
  return taxStatuses.includes('CORP') || taxStatuses.includes('Tax');
}

export function isSeriesNotTaxable(series: BasicSeries) {
  const taxStatus = taxStatusGetterForSeries(series, true);

  return taxStatus === 'T-E' || taxStatus === 'AMT';
}
